// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200022/js/" + chunkId + "." + {"44":"136884fd","225":"8fbd80d4","481":"d272c5ac","486":"b3cd8a8c","770":"86945a7d"}[chunkId] + ".0.29149089553877405.chunk.js";
};